<template>
    <v-container fluid no-gutters class="mx-0 px-0">
        <!-- Attach overlay to body and bump z-index so it sits above v-dialogs (v-dialog uses portals) -->
        <v-overlay :value="overlay" attach="body" absolute :style="{ zIndex: 2147483647 }">
            <v-progress-circular
                color="orange"
                indeterminate
                size="64"
                :style="{ zIndex: 2147483647 }"
            />
        </v-overlay>
        <v-row id="stats" justify="center" align="center" class="font-weight-bold mx-0 px-0">
            <v-col cols="2" @click="gameStatsDialog = true">
                <div>
                    <span :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'rebounds')[0].team1.rebounds }}
                    </span>
                    Rebounds
                </div>
                <div>
                    <span :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'steals')[0].team1.steals }}
                    </span>
                    Steals
                </div>
                <div>
                    <span :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'assists')[0].team1.assists }}
                    </span>
                    Assists
                </div>
                <div>
                    <span :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'turnovers')[0].team1.turnovers }}
                    </span>
                    Turnovers
                </div>
                <div>
                    <span :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'blockedShots')[0].team1.blockedShots }}
                    </span>
                    Blocks
                </div>
                <div>
                    <span :style="`color: #CD5C5C;`">
                        {{ team1Fouls }}
                    </span>
                    Fouls
                </div>
            </v-col>
            <v-col
                cols="2"
                align="center"
                class="mx-0 px-0 rounded-xl py-2 mb-2"
                :class="currentTeam === 1 ? 'selectedPlayer' : ''"
                :style="`background-color: #CD5C5C;`"
                @click="currentTeam === 1 ? (currentTeam = null, selectedPlayer = null) : currentTeam = 1"
            >
                <div>
                    <v-btn rounded outlined dark @click.stop="setGameRoster(1)" class="mb-1">set game roster</v-btn>
                </div>
                <v-avatar style="border-radius: 10px;" size="60" color="white">
                    <v-img width="40px" height="auto" :src="getCountryFlagUrl(match.team1.name)" />
                </v-avatar>
                <div class="font-weight-bold white--text">{{ `${match.team1.name}` }}</div>
                <div class="mx-2" style="font-size: 40px; color: white;">{{ `${match.scoreTeam1}` }}</div>
            </v-col>
            <v-col cols="4" align="center" class="pt-1">
                <div class="mb-1">
                    <v-icon color="orange" @click="feedDialog = true">
                        mdi-rss
                    </v-icon>
                    {{ `${ getMatchTitle() + ', ' + (match.phase === 'regular_season' ? 'Regular Season' : (match.phase === 'placements' ? 'Προκριματικά' : 'Play Offs')) },` }}
                    {{ `Round ${match.round}, ${matchDate}` }}
                </div>
                <v-select
                    v-model="quarter"
                    style="display: inline-flex; width:50px; font-size: 20px;"
                    label="Quarter"
                    :items="[1,2,3,4,5,6,7,8,9,10]"
                    hide-details
                />
                <span class="mx-5">
                    <v-btn dark outlined class="rounded-lg py-5" :color="'#CD5C5C'" @click="timeout()">timeout</v-btn>
                </span>
                <span class="">
                    <v-btn dark color="error" class="px-2" @click="endMatchDialog = true">
                        End match
                    </v-btn>
                    <v-dialog
                        v-model="endMatchDialog"
                        width="500"
                        hide-overlay
                        persistent
                        transition="dialog-bottom-transition"
                        :fullscreen="true"
                    >
                        <v-card dark class="py-5 px-5">
                            <v-row align="center" justify="center">
                                <v-col cols="12" align="center">
                                    <span class="font-weight-bold"> Are you sure? </span>
                                </v-col>
                                <v-col cols="6" align="end">
                                    <v-btn dark color="success" @click="endMatch()">
                                        yes
                                    </v-btn>
                                </v-col>
                                <v-col cols="6" align="start">
                                    <v-btn dark color="error" @click="endMatchDialog = false">
                                        no
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </span>
                <div class="match-timer py-1 mt-2 d-flex align-center justify-center">
                    <span class="d-flex align-center">
                        <v-btn icon large dark color="black" @click="switchTimer()">
                            <v-icon large dark>{{ paused ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                        </v-btn>
                    </span>
                    <span style="font-size: 30px;" class="mx-10 d-flex align-center">
                        {{ `${minutes}:${seconds}` }}
                    </span>
                    <v-btn icon x-large color="black" @click="timerDialog = true">
                        <v-icon color="black">mdi-timer-edit-outline</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col
                cols="2"
                align="center"
                class="mx-0 px-0 rounded-xl mb-2 py-2"
                :class="currentTeam === 2 ? 'selectedPlayer' : ''"
                :style="`background-color: #008080;`"
                @click="currentTeam === 2 ? (currentTeam = null, selectedPlayer = null) : currentTeam = 2"
            >
                <div>
                    <v-btn rounded outlined dark @click.stop="setGameRoster(2)" class="mb-1">set game roster</v-btn>
                </div>
                <v-avatar style="border-radius: 10px;" size="60" color="white">
                    <v-img width="40px" height="auto" :src="getCountryFlagUrl(match.team2.name)" />
                </v-avatar>
                <div class="font-weight-bold white--text">{{ `${match.team2.name}` }}</div>
                <div class="mx-2" style="font-size: 40px; color: white;">{{ `${match.scoreTeam2}` }}</div>
            </v-col>
            <v-col cols="2" align="end" @click="gameStatsDialog = true">
                <div>
                    Rebounds
                    <span :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'rebounds')[0].team2.rebounds }}
                    </span>
                </div>
                <div>
                    Steals
                    <span :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'steals')[0].team2.steals }}
                    </span>
                </div>
                <div>
                    Assists
                    <span :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'assists')[0].team2.assists }}
                    </span>
                </div>
                <div>
                    Turnovers
                    <span :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'turnovers')[0].team2.turnovers }}
                    </span>
                </div>
                <div>
                    Blocks
                    <span :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'blockedShots')[0].team2.blockedShots }}
                    </span>
                </div>
                <div>
                    Fouls
                    <span :style="`color: #008080;`">
                        {{ team2Fouls }}
                    </span>
                </div>
            </v-col>
            <v-col cols="3" align="center" class="mx-0 px-0 my-0 py-0">
                <v-row
                    v-for="player in team1SelectedPlayers"
                    :key="player.id"
                    class="mx-0 px-0 py-2"
                    justify="center"
                    align="center"
                    @click="(selectedPlayer && selectedPlayer.id === player.id) ? (selectedPlayer = null, currentTeam = null) : (selectedPlayer = player, currentTeam = 1)"
                >
                    <v-col cols="12" class="mx-0 px-0 my-0 py-0" align="center">
                        <v-card
                            class="rounded-xl d-flex align-center justify-center"
                            :class="selectedPlayer && selectedPlayer.id === player.id ? 'selectedPlayer' : ''"
                            :style="`background: linear-gradient(110deg, #CD5C5C 30%, white 30%);`"
                        >
                            <span>
                                <v-icon v-if="mvp.id === player.id" large color="grey"> mdi-crown-outline </v-icon>
                                <v-icon v-else color="grey"> mdi-pound </v-icon>
                                {{ `${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                            </span>
                            <img
                                v-if="player.image"
                                :src="googleApiHost + '/' + player.image"
                                height="70px"
                                width="auto"
                            />
                            <v-icon v-else style="font-size: 70px;" :color="'#CD5C5C'"> mdi-account </v-icon>
                            <div style="position: absolute; top: 0; left: 15px; color: grey">{{ getPoints(player, team1) }}p</div>
                            <div style="position: absolute; top: 0; right: 15px; color: grey">{{ getRebounds(player, team1) }}r</div>
                            <div style="position: absolute; bottom: 0; left: 15px; color: grey">{{ getAssists(player, team1) }}a</div>
                            <div style="position: absolute; bottom: 0; right: 15px; color: grey">{{ getFouls(player, team1) }}f</div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" align="center" class="mx-0 px-0 py-0">
                <v-row class="mx-0 px-0 no-gutters" align="center" justify="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" class="rounded-lg" :dark="selectedPlayer != null" :disabled="!selectedPlayer" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="shootingChartDialog=true; choice = 'made';">
                            <v-icon>mdi-check</v-icon>
                            Made Shot
                        </v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" class="rounded-lg" :dark="selectedPlayer != null" :disabled="!selectedPlayer" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="shootingChartDialog=true; choice = 'missed';">
                            <v-icon>mdi-cancel</v-icon>
                            Missed Shot
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 mt-2 no-gutters" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null || currentTeam != null" :disabled="!selectedPlayer && !currentTeam" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="playersDialog=true; isPlayerActive();">sub</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null" :disabled="!selectedPlayer" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="dialog=true; foulsDialog = true; category = 'foul'">foul</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 mt-2 no-gutters" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null || currentTeam != null" :disabled="!selectedPlayer && !currentTeam" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="category = 'dreb'; setStat(selectedPlayer);">d. reb</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null || currentTeam != null" :disabled="!selectedPlayer && !currentTeam" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="category = 'oreb'; setStat(selectedPlayer);">o. reb</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 mt-2 no-gutters" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null || currentTeam != null" :disabled="!selectedPlayer && !currentTeam" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="category = 'to'; setStat(selectedPlayer);">to</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null" :disabled="!selectedPlayer" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="category = 'stl'; setStat(selectedPlayer);">stl</v-btn>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 mt-2 no-gutters" align="center">
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null" :disabled="!selectedPlayer" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="category = 'asst'; setStat(selectedPlayer);">asst</v-btn>
                    </v-col>
                    <v-col cols="6" align="center" class="px-0">
                        <v-btn width="95%" height="77px" :dark="selectedPlayer != null" :disabled="!selectedPlayer" large class="rounded-lg" :color="currentTeam ==1 ? '#CD5C5C' : '#008080'" @click="category = 'blk'; setStat(selectedPlayer);">blk</v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="3" align="center" class="mx-0 px-0 my-0 py-0">
                <v-row
                    v-for="player in team2SelectedPlayers"
                    :key="player.id"
                    class="mx-0 px-0 py-2"
                    justify="center"
                    align="center"
                    @click="(selectedPlayer && selectedPlayer.id === player.id) ? (selectedPlayer = null, currentTeam = null) : (selectedPlayer = player, currentTeam = 2)"
                >
                    <v-col cols="12" class="mx-0 px-0 my-0 py-0" align="center">
                        <v-card
                            class="rounded-xl d-flex align-center justify-center"
                            :class="selectedPlayer && selectedPlayer.id === player.id ? 'selectedPlayer' : ''"
                            :style="`background: linear-gradient(110deg, #008080 30%, white 30%);`"
                        >
                            <span>
                                <v-icon v-if="mvp.id === player.id" large color="grey"> mdi-crown-outline </v-icon>
                                <v-icon v-else color="grey"> mdi-pound </v-icon>
                                {{ `${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                            </span>
                            <img
                                v-if="player.image"
                                :src="googleApiHost + '/' + player.image"
                                height="70px"
                                width="auto"
                            />
                            <v-icon v-else style="font-size: 70px;" :color="'#008080'"> mdi-account </v-icon>
                            <div style="position: absolute; top: 0; left: 15px; color: grey">{{ getPoints(player, team2) }}p</div>
                            <div style="position: absolute; top: 0; right: 15px; color: grey">{{ getRebounds(player, team2) }}r</div>
                            <div style="position: absolute; bottom: 0; left: 15px; color: grey">{{ getAssists(player, team2) }}a</div>
                            <div style="position: absolute; bottom: 0; right: 15px; color: grey">{{ getFouls(player, team2) }}f</div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="no-gutters mt-4">
            <v-col cols="12" class="px-1">
                <v-expansion-panels dark>
                    <v-expansion-panel class="rounded-lg" :disabled="!currentTeam">
                        <v-expansion-panel-header
                            class="text-center d-flex justify-center align-center"
                            style="font-weight: bold;"
                            :style="`background-color: ${currentTeam == 1 ? '#CD5C5C' : currentTeam == 2 ? '#008080' : 'grey'}; color: white;`"
                        >
                            Bench Players
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="bench-scroll">
                                <span
                                    v-for="player in currentTeam == 1 ? team1BenchPlayers : currentTeam == 2 ? team2BenchPlayers : []"
                                    :key="player.id"
                                    class="bench-item"
                                >
                                    <div class="bench-entry" @click="selectedPlayer === player ? selectedPlayer = null : selectedPlayer = player">
                                        <v-avatar size="100px" left :class="selectedPlayer && selectedPlayer.id === player.id ? 'selectedPlayer' : ''">
                                            <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" contain width="100%" height="100%" />
                                            <v-icon v-else color="white" large> mdi-account </v-icon>
                                        </v-avatar>
                                        <div class="bench-text">
                                            <v-text-field
                                                v-model="player.alternativeJersey"
                                                color="white"
                                                dark
                                                append-icon="mdi-pencil"
                                                prepend-icon="mdi-pound"
                                                :placeholder="player.jersey"
                                                single-line
                                                hide-details
                                                style="width: 180px; border: 1px solid white; border-radius: 5px;"
                                                class="px-2 py-2 mx-auto"
                                                @click:append="updateSelectedPlayerAlternativeJersey"
                                            />
                                            <div :style="selectedPlayer && selectedPlayer.id === player.id ? 'color: orangered' : 'color: white;'">
                                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey}` }}
                                                {{ `${player.name}(${player.jersey})` }}
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-dialog
            v-model="gameRosterDialog"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-toolbar app width="100%" height="100px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-h4" align="center">
                            {{ `Game Roster: ${currentTeam == 1? match.gameRosterTeam1.length : match.gameRosterTeam2.length}` }}
                        </v-col>
                        <v-btn
                            outlined
                            dark
                            color="white"
                            class="mb-2"
                            @click="saveGameRoster()"
                        >
                            set game roster
                        </v-btn>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="gameRosterDialog = false; currentTeam = null;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-toolbar>
                <v-row
                    v-if="orientation === 'portrait'"
                    align="center"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        v-for="player in currentTeam == 1? team1Players : team2Players"
                        :key="player.id"
                        cols="12"
                        align="start"
                    >
                        <v-avatar size="100px" left color="grey">
                            <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                            <v-icon v-else color="white" large> mdi-account </v-icon>
                        </v-avatar>
                        {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                        <v-btn
                            v-if="currentTeam == 1? match.gameRosterTeam1.find(element => player.id === element) : match.gameRosterTeam2.find(element => player.id === element)"
                            icon
                            color="red"
                            class="mx-2"
                            @click="currentTeam == 1 ? match.gameRosterTeam1 = match.gameRosterTeam1.filter(element => player.id !== element) : match.gameRosterTeam2 = match.gameRosterTeam2.filter(element => player.id !== element)"
                        >
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>
                            out
                        </v-btn>
                        <v-btn
                            v-else
                            icon
                            color="green"
                            class="mx-2"
                            @click="currentTeam == 1 ? match.gameRosterTeam1.push(player.id) : match.gameRosterTeam2.push(player.id)"
                        >
                            in
                            <v-icon>
                                mdi-arrow-right
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    v-else
                    align="start"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in currentTeam == 1? team1Players : team2Players" :key="`player-${player.id}`">
                            <div v-if="currentTeam == 1? team1SelectedPlayers.find(element => player.id === element.id) : team2SelectedPlayers.find(element => player.id === element.id)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                                    <v-icon v-else color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="red"
                                    class="mx-2"
                                    @click="removePlayer(player)"
                                >
                                    <v-icon>
                                        mdi-arrow-left
                                    </v-icon>
                                    out
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in currentTeam == 1? team1Players : team2Players" :key="player.id">
                            <div v-if="currentTeam == 1? !team1SelectedPlayers.find(element => player.id === element.id) : !team2SelectedPlayers.find(element => player.id === element.id)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                                    <v-icon v-else color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="green"
                                    class="mx-2"
                                    @click="addPlayer(player)"
                                >
                                    in
                                    <v-icon>
                                        mdi-arrow-right
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="gameRosterDialog = false;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="playersDialog"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-toolbar app width="100%" height="100px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-h4" align="center">
                            {{ `Now playing: ${currentTeam == 1? team1SelectedPlayers.length : team2SelectedPlayers.length}` }}
                            <v-btn
                                large
                                color="white"
                                outlined
                                @click="subOutAll()"
                            >
                                Sub Out All
                                <v-icon> mdi-exit-run </v-icon>
                            </v-btn>
                        </v-col>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="playersDialog = false;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-toolbar>
                <v-row
                    v-if="orientation === 'portrait'"
                    align="center"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        v-for="player in getPlayers()"
                        :key="player.id"
                        cols="12"
                        align="start"
                    >
                        <v-avatar size="100px" left color="grey">
                            <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                            <v-icon v-else color="white" large> mdi-account </v-icon>
                        </v-avatar>
                        {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                        <v-btn
                            v-if="currentTeam == 1? team1SelectedPlayers.find(element => player.id === element.id) : team2SelectedPlayers.find(element => player.id === element.id)"
                            icon
                            color="red"
                            class="mx-2"
                            @click="removePlayer(player)"
                        >
                            <v-icon>
                                mdi-arrow-left
                            </v-icon>
                            out
                        </v-btn>
                        <v-btn
                            v-else
                            icon
                            color="green"
                            class="mx-2"
                            @click="addPlayer(player)"
                        >
                            in
                            <v-icon>
                                mdi-arrow-right
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    v-else
                    align="start"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in currentTeam == 1? team1Players : team2Players" :key="`player-${player.id}`">
                            <div v-if="currentTeam == 1? team1SelectedPlayers.find(element => player.id === element.id) : team2SelectedPlayers.find(element => player.id === element.id)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                                    <v-icon v-else color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="red"
                                    class="mx-2"
                                    @click="removePlayer(player)"
                                >
                                    <v-icon>
                                        mdi-arrow-left
                                    </v-icon>
                                    out
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col
                        cols="6"
                        align="start"
                    >
                        <div v-for="player in currentTeam == 1? team1Players : team2Players" :key="player.id">
                            <div v-if="currentTeam == 1? !team1SelectedPlayers.find(element => player.id === element.id) : !team2SelectedPlayers.find(element => player.id === element.id)" class="mb-4">
                                <v-avatar size="100px" left color="grey">
                                    <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                                    <v-icon v-else color="white" large> mdi-account </v-icon>
                                </v-avatar>
                                {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                                <v-btn
                                    icon
                                    color="green"
                                    class="mx-2"
                                    @click="addPlayer(player)"
                                >
                                    in
                                    <v-icon>
                                        mdi-arrow-right
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="playersDialog = false;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialog"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-app-bar class="py-2" width="100%" height="150px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col v-if="statDialog" cols="12" class="text-h6" align="center">
                            {{ currentTeam === 1 ? match.team1.name : match.team2.name }}
                            <div>
                                <v-text-field
                                    v-model="selectedPlayer.alternativeJersey"
                                    color="white"
                                    dark
                                    append-icon="mdi-pencil"
                                    prepend-icon="mdi-pound"
                                    :placeholder="selectedPlayer.jersey"
                                    single-line
                                    hide-details
                                    style="width: 180px; border: 1px solid white; border-radius: 5px;"
                                    class="px-2 py-2"
                                    @click:append="updateSelectedPlayerAlternativeJersey"
                                />
                                <span> {{ `#${selectedPlayer.alternativeJersey || selectedPlayer.alternativeJersey === 0 ? selectedPlayer.alternativeJersey : selectedPlayer.jersey}` }} </span>
                                {{ `${selectedPlayer.name}(${selectedPlayer.jersey})` }}
                            </div>
                        </v-col>
                        <v-col v-else cols="12" class="text-h6" align="center">
                            {{ getCategoryText(category) }}
                        </v-col>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="dialog = false; choice = null; pointsDialog = false; foulsDialog = false; reboundDialog = false; category = null; statDialog = false; selectedPlayer = null;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-app-bar>
                <v-row v-if="reboundDialog" class="px-5 pb-5 pt-16" align="center" justify="center">
                    <v-col cols="12" align="center">
                        <v-btn
                            :color="currentTeam === 1 ? '#008080' : '#CD5C5C'"
                            dark
                            @click="category = 'dreb'; reboundDialog = false; currentTeam = currentTeam === 1 ? 2 : 1;"
                        >
                            Defensive Rebound
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            :color="currentTeam === 1 ? '#CD5C5C' : '#008080'"
                            dark
                            @click="category = 'oreb'; reboundDialog = false;"
                        >
                            Offensive Rebound
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else-if="choice === null && pointsDialog" class="px-5 pb-5 pt-16" align="center" justify="center">
                    <v-col cols="12" align="center">
                        <v-btn
                            color="black"
                            dark
                            @click="setChoice('made')"
                        >
                            <v-icon color="success"> mdi-check </v-icon>
                            made
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            color="black"
                            dark
                            @click="setChoice('missed')"
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                            missed
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-else-if="choice === null && foulsDialog" class="px-5 pb-5 pt-16" align="center" justify="center">
                    <v-col cols="12" align="center">
                        <v-btn
                            color="warning"
                            dark
                            @click="setChoice('personal')"
                        >
                            personal
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            color="error"
                            dark
                            @click="setChoice('technical')"
                        >
                            technical
                        </v-btn>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn
                            color="black"
                            dark
                            @click="setChoice('unsportsmanlike')"
                        >
                            unsportsmanlike
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    v-else
                    align="center"
                    justify="center"
                    class="px-5 pb-5 pt-5"
                    style="cursor: pointer;"
                >
                    <v-col
                        v-for="player in currentTeam == 1? team1SelectedPlayers : team2SelectedPlayers"
                        :key="player.id"
                        cols="12"
                        align="start"
                        @click="selectedPlayer = player; setChoice(made)"
                    >
                        <v-avatar size="100px" color="grey" left>
                            <v-img v-if="player.image" :src="googleApiHost + '/' + player.image" />
                            <v-icon v-else color="white" large> mdi-account </v-icon>
                        </v-avatar>
                        {{ `#${player.alternativeJersey || player.alternativeJersey === 0 ? player.alternativeJersey : player.jersey} ${player.name}` }}
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="dialog = false; choice = null; pointsDialog = false; foulsDialog = false; reboundDialog = false; category = null; statDialog = false; selectedPlayer = null;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="retry"
            width="100%"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-alert
                prominent
                type="error"
            >
                <v-row align="center">
                    <v-col class="grow">
                        Oops something went wrong...
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="setStat(selectedPlayer)">Retry</v-btn>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn @click="retry=false; dialog = false; pointsDialog = false; foulsDialog = false; reboundDialog = false; playersDialog = false; overlay = false">Close</v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </v-dialog>
        <v-dialog
            v-model="shootingChartDialog"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            class="mx-2"
            :fullscreen="true"
        >
            <v-card>
                <v-app-bar class="py-2" width="100%" height="100px" style=" position: sticky; top: 0; z-index: 1000000000; color: white;" :style="currentTeam === 1 ? `background-color: #CD5C5C;` : `background-color: #008080;`">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-h4" align="center">
                            Shooting Chart
                        </v-col>
                        <v-btn
                            icon
                            large
                            style="position: absolute; top:0; right:0;"
                            color="white"
                            @click="shootingChartDialog = false; dialog = false; choice = null; pointsDialog = false; foulsDialog = false; reboundDialog = false; category = null; statDialog = false; selectedPlayer = null;"
                        >
                            <v-icon> mdi-close </v-icon>
                        </v-btn>
                    </v-row>
                </v-app-bar>
                <v-row align="center" justify="center">
                    <v-col cols="12" class="text-h4" align="center">
                        <v-btn
                            color="blue"
                            outlined
                            @click="category = '1pt'; setStat(selectedPlayer); shootingChartDialog = false;"
                            class="text-center align-center justify-center"
                        >
                            Free Throw
                        </v-btn>
                    </v-col>
                </v-row>
                <shooting-chart v-if="shootingChartDialog" class="mt-5" :made="choice === 'made'" @updateShots="updateShots" @setCategory="setCategory" />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="green"
                        outlined
                        :disabled="shots.length === 0"
                        @click="setStat(selectedPlayer); shootingChartDialog = false;"
                    >
                        apply
                    </v-btn>
                    <v-btn
                        v-if="choice === 'missed'"
                        color="black"
                        outlined
                        text
                        :disabled="shots.length === 0"
                        @click="putBack(selectedPlayer); shootingChartDialog = false;"
                    >
                        put back
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="timerDialog"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-row align="center" justify="center">
                    <v-col cols="5">
                        <v-text-field
                            v-model="newMinutes"
                            type="number"
                            label="enter minutes"
                        />
                    </v-col>
                    <v-col cols="2" align="center">
                        :
                    </v-col>
                    <v-col cols="5">
                        <v-text-field
                            v-model="newSeconds"
                            type="number"
                            label="enter seconds"
                        />
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        text
                        @click="timerDialog = false; changeTimer()"
                    >
                        apply
                    </v-btn>
                    <v-btn
                        color="error"
                        text
                        @click="timerDialog = false; newMinutes = null; newSeconds = null"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="gameStatsDialog"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card>
                <v-row class="pt-1" justify="center" align="center">
                    <v-col
                        cols="6"
                        align="center"
                        :class="currentTeam === 1 ? 'selectedPlayer' : ''"
                        :style="`background-color: #CD5C5C;`"
                    >
                        <v-img width="40px" height="auto" :src="googleApiHost + '/' + match.team1.logo" />
                        <span class="font-weight-bold white--text">{{ `${match.team1.name}` }}</span>
                        <div class="mx-2" style="font-size: 40px; color: white;">{{ `${match.scoreTeam1}` }}</div>
                    </v-col>
                    <v-col
                        cols="6"
                        align="center"
                        :class="currentTeam === 1 ? 'selectedPlayer' : ''"
                        :style="`background-color: #008080;`"
                    >
                        <v-img width="40px" height="auto" :src="googleApiHost + '/' + match.team2.logo" />
                        <span class="font-weight-bold white--text">{{ `${match.team2.name}` }}</span>
                        <div class="mx-2" style="font-size: 40px; color: white;">{{ `${match.scoreTeam2}` }}</div>
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 mt-2 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'rebounds')[0].team1.rebounds }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Rebounds
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'rebounds')[0].team2.rebounds }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'steals')[0].team1.steals }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Steals
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'steals')[0].team2.steals }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'assists')[0].team1.assists }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Assists
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'assists')[0].team2.assists }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'turnovers')[0].team1.turnovers }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Turnovers
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'turnovers')[0].team2.turnovers }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'blockedShots')[0].team1.blockedShots }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Blocks
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'blockedShots')[0].team2.blockedShots }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'personalFouls')[0].team1.personalFouls }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        Fouls
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'personalFouls')[0].team2.personalFouls }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'technicalFouls')[0].team1.technicalFouls }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        T.Fouls
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'technicalFouls')[0].team2.technicalFouls }}
                    </v-col>
                </v-row>
                <v-row class="mx-0 px-0 my-0 py-0" justify="center" align="center">
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #CD5C5C;`">
                        {{ stats.filter(element => element.value === 'unsportsmanlikeFouls')[0].team1.unsportsmanlikeFouls }}
                    </v-col>
                    <v-col cols="6" align="center" class="mx-0 px-0">
                        U.Fouls
                    </v-col>
                    <v-col cols="3" align="center" class="mx-0 px-0" :style="`color: #008080;`">
                        {{ stats.filter(element => element.value === 'unsportsmanlikeFouls')[0].team2.unsportsmanlikeFouls }}
                    </v-col>
                </v-row>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        text
                        @click="gameStatsDialog = false;"
                    >
                        close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="feedDialog"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
            :fullscreen="true"
        >
            <v-card outlined class="py-2 rounded-lg" style="border: 2px solid black;">
                <v-btn icon style="position: absolute; top:-5px; left: 5px;" @click="feedDialog = false">
                    <v-icon color="black">
                        mdi-close
                    </v-icon>
                </v-btn>
                <div class="font-weight-bold text-center">
                    <span>Feed:</span>
                    <span>
                        <v-text-field
                            v-model="feedFilter"
                            placeholder="filter feed by jersey..."
                            dense
                            hide-details
                            class="my-2 ml-3"
                            style="display: inline-flex;"
                            append-icon="mdi-magnify"
                        />
                    </span>
                    <div class="d-flex justify-end px-2">
                        <v-btn
                            depressed
                            outlined
                            color="warning"
                            small
                            @click="deleteAllLogsDialog = true"
                        >
                            <v-icon
                                color="warning"
                            >
                                mdi-alert
                            </v-icon>
                            Delete feed
                            <v-icon
                                color="warning"
                            >
                                mdi-alert
                            </v-icon>
                        </v-btn>
                    </div>
                    <v-dialog
                        v-model="deleteAllLogsDialog"
                        width="500"
                        hide-overlay
                        persistent
                        transition="dialog-bottom-transition"
                        :fullscreen="true"
                    >
                        <v-card dark class="py-5 px-5">
                            <v-row align="center" justify="center">
                                <v-col cols="12" align="center">
                                    <span class="font-weight-bold"> Are you sure? </span>
                                </v-col>
                                <v-col cols="6" align="end">
                                    <v-btn dark color="success" @click="deleteAllLogs()">
                                        yes
                                    </v-btn>
                                </v-col>
                                <v-col cols="6" align="start">
                                    <v-btn dark color="error" @click="deleteAllLogsDialog = false">
                                        no
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </div>
                <v-virtual-scroll
                    :items="filterFeed()"
                    :item-height="50"
                    height="650px"
                >
                    <template v-slot:default="{ item }">
                        <v-list-item style="font-size: 16px;">
                            <span style="display: inline-flex;">{{ item.timestamp }}</span>
                            <v-avatar class="mx-2 rounded-xl" style="display: inline-flex;" :style="item.teamId === team1? `background-color: #CD5C5C;` : `background-color: #008080;`">
                                <v-img contain height="30px" :src="getTeamLogo(item)" />
                            </v-avatar>
                            <span style="display: inline-flex;">{{ getLogText(item) }}</span>
                            <v-icon
                                v-if="item.playerMatchStatus === 'stop'"
                                icon
                                color="red"
                                class="mx-2"
                            >
                                mdi-arrow-left
                            </v-icon>
                            <v-icon
                                v-else-if="item.playerMatchStatus === 'begin'"
                                icon
                                color="green"
                                class="mx-2"
                            >
                                mdi-arrow-right
                            </v-icon>
                            <v-spacer />
                            <v-list-item-action>
                                <v-btn
                                    depressed
                                    icon
                                    small
                                    @click="deleteDialog = true; logId = item.logId"
                                >
                                    <v-icon
                                        color="error"
                                    >
                                        mdi-trash-can
                                    </v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </template>
                </v-virtual-scroll>
                <v-dialog
                    v-model="deleteDialog"
                    width="500"
                    hide-overlay
                    persistent
                    transition="dialog-bottom-transition"
                    :fullscreen="true"
                >
                    <v-card dark class="py-5 px-5">
                        <v-row align="center" justify="center">
                            <v-col cols="12" align="center">
                                <span class="font-weight-bold"> Are you sure? </span>
                            </v-col>
                            <v-col cols="6" align="end">
                                <v-btn dark color="success" @click="deleteLog()">
                                    yes
                                </v-btn>
                            </v-col>
                            <v-col cols="6" align="start">
                                <v-btn dark color="error" @click="deleteDialog = false">
                                    no
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-dialog>
        <!-- Snackbar for success/error messages -->
        <v-snackbar v-model="showSnackbar" :color="snackbarColor" timeout="3000" top>
            {{ snackbarText }}
            <v-btn text @click="showSnackbar = false">Close</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import matchService from '@/services/match'
    import playerService from '@/services/player'
    import momentTimezone from 'moment-timezone'
    import teamService from '@/services/team'
    import ShootingChart from '@/components/ShootingChart.vue'

    export default {
        components: {
            ShootingChart
        },
        data: () => {
            return {
                feedDialog: false,
                gameStatsDialog: false,
                deleteAllLogsDialog: false,
                shootingChartDialog: false,
                shots: [],
                orientation: 'portrait',
                retry: false,
                statDialog: false,
                deleteDialog: false,
                endMatchDialog: false,
                reboundDialog: false,
                dialog: false,
                playersDialog: false,
                matchDate: null,
                match: {
                    league: null,
                    cupLeague: null,
                    team1: {
                        id: null,
                        name: '',
                        color: '#000000'
                    },
                    gameRosterTeam1: [],
                    team2: {
                        id: null,
                        name: '',
                        color: '#000000'
                    },
                    gameRosterTeam2: []
                },
                googleApiHost: 'https://storage.googleapis.com',
                paused: false,
                team1Players: [],
                team1SelectedPlayers: [],
                team2Players: [],
                team2SelectedPlayers: [],
                currentTeam: null,
                team1: null,
                team1Fouls: 0,
                team2: null,
                team2Fouls: 0,
                pointsDialog: false,
                foulsDialog: false,
                choice: null,
                category: null,
                timer: 600000,
                newMinutes: null,
                newSeconds: null,
                timerDialog: false,
                timerInterval: null,
                feed: [],
                logId: null,
                quarter: 1,
                selectedPlayer: null,
                overlay: false,
                matchStats: {
                    'team1': {
                        'name': '',
                        'players': []
                    },
                    'team2': {
                        'name': '',
                        'players': []
                    }
                },
                created: true,
                stats: [
                    { text: 'Pts', value: 'points', team1: { player: null, points: 0 }, team2: { player: null, points: 0 } },
                    { text: '2P%', value: 'two_points_percentage', team1: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 }, team2: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 } },
                    { text: '3P%', value: 'three_points_percentage', team1: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 }, team2: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 } },
                    { text: 'FT%', value: 'free_throw_percentage', team1: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 }, team2: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 } },
                    { text: 'OR', value: 'offensiveRebounds', team1: { player: null, offensiveRebounds: 0 }, team2: { player: null, offensiveRebounds: 0 } },
                    { text: 'DR', value: 'defensiveRebounds', team1: { player: null, defensiveRebounds: 0 }, team2: { player: null, defensiveRebounds: 0 } },
                    { text: 'TR', value: 'rebounds', team1: { player: null, rebounds: 0 }, team2: { player: null, rebounds: 0 } },
                    { text: 'AST', value: 'assists', team1: { player: null, assists: 0 }, team2: { player: null, assists: 0 } },
                    { text: 'STL', value: 'steals', team1: { player: null, steals: 0 }, team2: { player: null, steals: 0 } },
                    { text: 'TO', value: 'turnovers', team1: { player: null, turnovers: 0 }, team2: { player: null, turnovers: 0 } },
                    { text: 'BLK', value: 'blockedShots', team1: { player: null, blockedShots: 0 }, team2: { player: null, blockedShots: 0 } },
                    { text: 'FC', value: 'personalFouls', team1: { player: null, personalFouls: 0 }, team2: { player: null, personalFouls: 0 } },
                    { text: 'TFC', value: 'technicalFouls', team1: { player: null, technicalFouls: 0 }, team2: { player: null, technicalFouls: 0 } },
                    { text: 'USF', value: 'unsportsmanlikeFouls', team1: { player: null, unsportsmanlikeFouls: 0 }, team2: { player: null, unsportsmanlikeFouls: 0 } }
                ],
                made: false,
                mvp: { id: null, points: 0 },
                // snackbar for user feedback
                showSnackbar: false,
                snackbarText: '',
                snackbarColor: 'success',
                feedFilter: null,
                gameRosterDialog: false
            }
        },
        computed: {
            minutes() {
                let temp = Math.floor(this.timer / 60000)
                return (temp < 10 ? '0' : '') + temp
            },
            seconds() {
                let temp = Math.floor(((this.timer % 60000) / 1000))
                return (temp < 10 ? '0' : '') + temp
            },
            team1BenchPlayers() {
                if (this.match.gameRosterTeam1) {
                    if (this.match.gameRosterTeam1.length === 0) {
                        return this.team1Players.filter(p => !this.team1SelectedPlayers.some(sel => sel.id === p.id))
                    } else {
                        return this.team1Players.filter(p =>
                            !this.team1SelectedPlayers.some(sel => sel.id === p.id) &&
                            this.match.gameRosterTeam1.includes(p.id))
                    }
                }
                return this.team1Players.filter(p => !this.team1SelectedPlayers.some(sel => sel.id === p.id))
            },
            team2BenchPlayers() {
                if (this.match.gameRosterTeam2) {
                    if (this.match.gameRosterTeam2.length === 0) {
                        return this.team2Players.filter(p => !this.team2SelectedPlayers.some(sel => sel.id === p.id))
                    } else {
                        return this.team2Players.filter(p =>
                            !this.team2SelectedPlayers.some(sel => sel.id === p.id) &&
                            this.match.gameRosterTeam2.includes(p.id))
                    }
                }
                return this.team2Players.filter(p => !this.team2SelectedPlayers.some(sel => sel.id === p.id))
            }
        },
        watch: {
            match() {
                this.getFeed()
                this.getMatchStats()
            },
            timer() {
                if (this.timer === 0 && !this.created) {
                    this.quarter = this.quarter + 1
                    if (this.quarter <= 4) {
                        this.newMinutes = 10
                    } else {
                        this.newMinutes = 5
                    }
                    this.newSeconds = 0
                    this.changeTimer()
                    this.pauseTimer()
                }
            },
            quarter() {
                this.setQuarterFouls()
                if (this.quarter <= 4) {
                    if (!this.created) {
                        this.newMinutes = 10
                        this.newSeconds = 0
                        this.changeTimer()
                        this.pauseTimer()
                    }
                } else {
                    if (!this.created) {
                        this.newMinutes = 5
                        this.newSeconds = 0
                        this.changeTimer()
                        this.pauseTimer()
                    }
                }
                this.created = false
            }
        },
        beforeCreate() {
        },
        created() {
            this.getMatch()
        },
        methods: {
            getCountryFlagUrl(teamName) {
                const country = teamName.split('-')[0].trim()
                console.log('Country:', country)
                const countryCode = this.$countries.getAlpha2Code(country, 'en')
                console.log('Country code:', countryCode)
                if (country === 'MOLDOVA') {
                    return 'https://flagcdn.com/w320/md.png'
                }
                if (!countryCode) {
                    return `https://flagcdn.com/w320/${country.toLowerCase()}.png`
                }
                return `https://flagcdn.com/w320/${countryCode.toLowerCase()}.png`
            },
            getPlayers() {
                if (this.currentTeam === 1) {
                    if (this.match.gameRosterTeam1.length === 0) {
                        return this.team1Players
                    } else {
                        return this.team1Players.filter(player => this.match.gameRosterTeam1.includes(player.id))
                    }
                } else {
                    if (this.match.gameRosterTeam2.length === 0) {
                        return this.team2Players
                    } else {
                        return this.team2Players.filter(player => this.match.gameRosterTeam2.includes(player.id))
                    }
                }
            },
            saveGameRoster() {
                if (this.currentTeam === 1) {
                    matchService.updateMatch(this.match.id, this.match).then(() => {
                        // show success snackbar
                        this.snackbarText = 'Game roster updated successfully'
                        this.snackbarColor = 'success'
                        this.showSnackbar = true
                    }).catch(() => {
                        // show error snackbar
                        this.snackbarText = 'Game roster didnt updated due to an error'
                        this.snackbarColor = 'error'
                        this.showSnackbar = true
                    })
                } else {
                    matchService.updateMatch(this.match.id, this.match).then(() => {
                        // show success snackbar
                        this.snackbarText = 'Game roster updated successfully'
                        this.snackbarColor = 'success'
                        this.showSnackbar = true
                    }).catch(() => {
                        // show error snackbar
                        this.snackbarText = 'Game roster didnt updated due to an error'
                        this.snackbarColor = 'error'
                        this.showSnackbar = true
                    })
                }
                this.gameRosterDialog = false
            },
            setGameRoster(team) {
                if (team === 1) {
                    this.currentTeam = 1
                    this.gameRosterDialog = true
                } else {
                    this.currentTeam = 2
                    this.gameRosterDialog = true
                }
            },
            filterFeed() {
                if (this.feedFilter) {
                    return this.feed.filter(log => {
                        return log.alternativeJersey ? (log.alternativeJersey !== null && log.alternativeJersey !== undefined && log.alternativeJersey.toString() === this.feedFilter) : (log.jersey !== null && log.jersey !== undefined && log.jersey.toString() === this.feedFilter)
                    })
                } else {
                    return this.feed
                }
            },
            isPlayerActive() {
                if (this.currentTeam === 1) {
                    if (this.team1SelectedPlayers.find(element => element.id === this.selectedPlayer.id) !== undefined) {
                        this.removePlayer(this.selectedPlayer)
                    }
                } else {
                    if (this.team2SelectedPlayers.find(element => element.id === this.selectedPlayer.id) !== undefined) {
                        this.removePlayer(this.selectedPlayer)
                    }
                }
            },
            setCategory(category) {
                this.category = category
            },
            subOutAll() {
                if (this.currentTeam === 1) {
                    this.team1SelectedPlayers.forEach((player) => {
                        this.removePlayer(player)
                    })
                    this.team1SelectedPlayers = []
                } else {
                    this.team2SelectedPlayers.forEach((player) => {
                        this.removePlayer(player)
                    })
                    this.team2SelectedPlayers = []
                }
            },
            getPoints(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].points
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].points
                }
            },
            getRebounds(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].rebounds
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].rebounds
                }
            },
            getAssists(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].assists
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].assists
                }
            },
            getFouls(player, team) {
                if (team === this.matchStats.team1.id) {
                    if (!this.matchStats || !this.matchStats.team1.players.filter(element => element.id === player.id)[0] || !this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].personalFouls + this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].technicalFouls + this.matchStats.team1.players.filter(element => element.id === player.id)[0].stats[0].unsportsmanlikeFouls
                } else {
                    if (!this.matchStats || !this.matchStats.team2.players.filter(element => element.id === player.id)[0] || !this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0]) {
                        return 0
                    }
                    return this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].personalFouls + this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].technicalFouls + this.matchStats.team2.players.filter(element => element.id === player.id)[0].stats[0].unsportsmanlikeFouls
                }
            },
            getMatchTitle() {
                if (this.match.cupLeague) {
                    return this.match.cupLeague.title
                } else if (this.match.league) {
                    return this.match.league.title
                } else {
                    return 'Friendly'
                }
            },
            deleteAllLogs() {
                matchService.deleteAllLogs(this.match.id).then(() => {
                    this.deleteAllLogsDialog = false
                    this.getFeed()
                    this.getMatch()
                    this.getActivePlayers()
                }).catch(() => {
                    this.deleteAllLogsDialog = false
                })
            },
            updateShots(shots) {
                this.shots = shots
            },
            setQuarterFouls() {
                this.team1Fouls = this.feed.reduce((acc, log) => {
                    if ((this.quarter <= 4 ? (this.quarter - 1) * 10 : 3 * 10) <= parseInt(log.timestamp.split(':')[0]) && parseInt(log.timestamp.split(':')[0]) < this.quarter * 10 && this.team1 === log.teamId) {
                        return acc +
                            (typeof log.personalFouls !== 'undefined' ? log.personalFouls : 0) +
                            (typeof log.technicalFouls !== 'undefined' ? log.technicalFouls : 0) +
                            (typeof log.unsportsmanlikeFouls !== 'undefined' ? log.unsportsmanlikeFouls : 0)
                    } else {
                        return acc
                    }
                }, 0)
                this.team2Fouls = this.feed.reduce((acc, log) => {
                    if ((this.quarter <= 4 ? (this.quarter - 1) * 10 : 3 * 10) <= parseInt(log.timestamp.split(':')[0]) && parseInt(log.timestamp.split(':')[0]) < this.quarter * 10 && this.team2 === log.teamId) {
                        return acc +
                            (typeof log.personalFouls !== 'undefined' ? log.personalFouls : 0) +
                            (typeof log.technicalFouls !== 'undefined' ? log.technicalFouls : 0) +
                            (typeof log.unsportsmanlikeFouls !== 'undefined' ? log.unsportsmanlikeFouls : 0)
                    } else {
                        return acc
                    }
                }, 0)
            },
            getSecondsFromFeed() {
                return parseInt(this.feed[0].timestamp.split(':')[1])
            },
            getMinutesFromFeed() {
                return parseInt(this.feed[0].timestamp.split(':')[0])
            },
            getMinutes() {
                if (parseInt(this.minutes) === 10 || (parseInt(this.minutes) === 5 && this.quarter > 4)) {
                    if (this.quarter <= 4) {
                        return (this.quarter - 1) * 10
                    } else {
                        return 4 * 10 + (this.quarter - 5) * 5
                    }
                } else {
                    if (this.quarter <= 4) {
                        return (9 - parseInt(this.minutes)) + (this.quarter - 1) * 10
                    } else {
                        return (4 - parseInt(this.minutes)) + 4 * 10 + (this.quarter - 5) * 5
                    }
                }
            },
            getSeconds() {
                if (this.seconds === '00') {
                    return '00'
                } else if ((59 - this.seconds) < 10) {
                    return '0' + (59 - this.seconds)
                } else {
                    return (59 - this.seconds)
                }
            },
            changeOrientation() {
                if (this.$vuetify.breakpoint.xs) {
                    this.orientation = 'portrait'
                } else {
                    this.orientation === 'portrait' ? this.orientation = 'landscape' : this.orientation = 'portrait'
                }
            },
            getMatchValues(matchStats) {
                this.stats = [
                    { text: 'Pts', value: 'points', team1: { player: null, points: 0 }, team2: { player: null, points: 0 } },
                    { text: '2P%', value: 'two_points_percentage', team1: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 }, team2: { player: null, twoPointAttempts: 0, twoPointsMade: 0, two_points_percentage: 0 } },
                    { text: '3P%', value: 'three_points_percentage', team1: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 }, team2: { player: null, threePointAttempts: 0, threePointsMade: 0, three_points_percentage: 0 } },
                    { text: 'FT%', value: 'free_throw_percentage', team1: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 }, team2: { player: null, freeThrowAttempts: 0, freeThrowsMade: 0, free_throw_percentage: 0 } },
                    { text: 'OR', value: 'offensiveRebounds', team1: { player: null, offensiveRebounds: 0 }, team2: { player: null, offensiveRebounds: 0 } },
                    { text: 'DR', value: 'defensiveRebounds', team1: { player: null, defensiveRebounds: 0 }, team2: { player: null, defensiveRebounds: 0 } },
                    { text: 'TR', value: 'rebounds', team1: { player: null, rebounds: 0 }, team2: { player: null, rebounds: 0 } },
                    { text: 'AST', value: 'assists', team1: { player: null, assists: 0 }, team2: { player: null, assists: 0 } },
                    { text: 'STL', value: 'steals', team1: { player: null, steals: 0 }, team2: { player: null, steals: 0 } },
                    { text: 'TO', value: 'turnovers', team1: { player: null, turnovers: 0 }, team2: { player: null, turnovers: 0 } },
                    { text: 'BLK', value: 'blockedShots', team1: { player: null, blockedShots: 0 }, team2: { player: null, blockedShots: 0 } },
                    { text: 'FC', value: 'personalFouls', team1: { player: null, personalFouls: 0 }, team2: { player: null, personalFouls: 0 } },
                    { text: 'TFC', value: 'technicalFouls', team1: { player: null, technicalFouls: 0 }, team2: { player: null, technicalFouls: 0 } },
                    { text: 'USF', value: 'unsportsmanlikeFouls', team1: { player: null, unsportsmanlikeFouls: 0 }, team2: { player: null, unsportsmanlikeFouls: 0 } }
                ]
                this.stats.forEach((stat) => {
                    matchStats.team1.players.forEach((player) => {
                        if (player.stats.length > 0) {
                            if (stat.value === 'two_points_percentage') {
                                stat.team1.twoPointAttempts += player.stats[0].twoPointAttempts
                                stat.team1.twoPointsMade += player.stats[0].twoPointsMade
                            } else if (stat.value === 'three_points_percentage') {
                                stat.team1.threePointAttempts += player.stats[0].threePointAttempts
                                stat.team1.threePointsMade += player.stats[0].threePointsMade
                            } else if (stat.value === 'free_throw_percentage') {
                                stat.team1.freeThrowAttempts += player.stats[0].freeThrowAttempts
                                stat.team1.freeThrowsMade += player.stats[0].freeThrowsMade
                            } else {
                                stat.team1[stat.value] += player.stats[0][stat.value]
                            }
                        }
                    })
                    stat.team1.two_points_percentage = (stat.team1.twoPointsMade / (stat.team1.twoPointAttempts ? stat.team1.twoPointAttempts : 1) * 100).toFixed(0)
                    stat.team1.three_points_percentage = (stat.team1.threePointsMade / (stat.team1.threePointAttempts ? stat.team1.threePointAttempts : 1) * 100).toFixed(0)
                    stat.team1.free_throw_percentage = (stat.team1.freeThrowsMade / (stat.team1.freeThrowAttempts ? stat.team1.freeThrowAttempts : 1) * 100).toFixed(0)
                    matchStats.team2.players.forEach((player) => {
                        if (player.stats.length > 0) {
                            if (stat.value === 'two_points_percentage') {
                                stat.team2.twoPointAttempts += player.stats[0].twoPointAttempts
                                stat.team2.twoPointsMade += player.stats[0].twoPointsMade
                            } else if (stat.value === 'three_points_percentage') {
                                stat.team2.threePointAttempts += player.stats[0].threePointAttempts
                                stat.team2.threePointsMade += player.stats[0].threePointsMade
                            } else if (stat.value === 'free_throw_percentage') {
                                stat.team2.freeThrowAttempts += player.stats[0].freeThrowAttempts
                                stat.team2.freeThrowsMade += player.stats[0].freeThrowsMade
                            } else {
                                stat.team2[stat.value] += player.stats[0][stat.value]
                            }
                        }
                    })
                    stat.team2.two_points_percentage = (stat.team2.twoPointsMade / (stat.team2.twoPointAttempts ? stat.team2.twoPointAttempts : 1) * 100).toFixed(0)
                    stat.team2.three_points_percentage = (stat.team2.threePointsMade / (stat.team2.threePointAttempts ? stat.team2.threePointAttempts : 1) * 100).toFixed(0)
                    stat.team2.free_throw_percentage = (stat.team2.freeThrowsMade / (stat.team2.freeThrowAttempts ? stat.team2.freeThrowAttempts : 1) * 100).toFixed(0)
                })
            },
            getMatchStats() {
                matchService.getMatchStats(this.$route.params.matchId).then(resp => {
                    this.matchStats = resp.data
                    this.getMatchValues(resp.data)
                    this.setMvp()
                })
            },
            setMvp() {
                if (this.matchStats.team1Score === 0 && this.matchStats.team2Score === 0) {
                    this.mvp = { id: null, points: 0 }
                } else if (this.matchStats.team1Score > this.matchStats.team2Score) {
                    const team1PlayersWithPir = this.matchStats.team1.players.filter(p => p.stats && p.stats[0] && typeof p.stats[0].pir !== 'undefined')
                    this.mvp = team1PlayersWithPir.length > 0 ? team1PlayersWithPir.reduce((max, p) => p.stats[0].pir > max.stats[0].pir ? p : max, team1PlayersWithPir[0]) : null
                } else {
                    const team2PlayersWithPir = this.matchStats.team2.players.filter(p => p.stats && p.stats[0] && typeof p.stats[0].pir !== 'undefined')
                    this.mvp = team2PlayersWithPir.length > 0 ? team2PlayersWithPir.reduce((max, p) => p.stats[0].pir > max.stats[0].pir ? p : max, team2PlayersWithPir[0]) : null
                }
            },
            getCategoryText(category) {
                switch (category) {
                case '1pt':
                    return 'POINTS: 1'
                case '2pts':
                    return 'POINTS: 2'
                case '3pts':
                    return 'POINTS: 3'
                case 'dreb':
                    return 'DEFENSIVE REBOUND'
                case 'oreb':
                    return 'OFFENSIVE REBOUND'
                case 'to':
                    return 'TURNOVER'
                case 'stl':
                    return 'STEALS'
                case 'asst':
                    return 'ASSISTS'
                case 'blk':
                    return 'BLOCKS'
                case 'foul':
                    if (this.choice === 'personal') {
                        return 'PERSONAL FOUL'
                    } else if (this.choice === 'technical') {
                        return 'TECHNICAL FOUL'
                    } else {
                        return 'UNSPORTSMANLIKE FOUL'
                    }
                case 'sub-in':
                    return 'SUBSTITUTE IN ->'
                case 'sub-out':
                    return 'SUBSTITUTE OUT <-'
                default:
                    break
                }
            },
            sortPlayers(players) {
                if (players.length > 0) {
                    players.sort((a, b) => {
                        if ((a.alternativeJersey || a.alternativeJersey === 0 ? parseInt(a.alternativeJersey) : a.jersey) < (b.alternativeJersey || b.alternativeJersey === 0 ? parseInt(b.alternativeJersey) : b.jersey)) {
                            return -1
                        }
                        if ((a.alternativeJersey || a.alternativeJersey === 0 ? parseInt(a.alternativeJersey) : a.jersey) > (b.alternativeJersey || b.alternativeJersey === 0 ? parseInt(b.alternativeJersey) : b.jersey)) {
                            return 1
                        }
                        return 0
                    })
                } else {
                    return []
                }
            },
            setChoice(choice) {
                this.choice = choice
                if (this.selectedPlayer) {
                    if (this.category === '2pts' || this.category === '3pts') {
                        this.shootingChartDialog = true
                    } else {
                        this.setStat(this.selectedPlayer)
                    }
                }
            },
            endMatch() {
                let data = {
                    content: `${this.getMinutes()}:${this.getSeconds()}`
                }
                matchService.endMatch(this.$route.params.matchId, data).then(resp => {
                    this.endMatchDialog = false
                    this.$router.push({ name: 'Matches' })
                })
            },
            addPlayer(player) {
                if (this.currentTeam === 1 ? this.team1SelectedPlayers.length < 5 : this.team2SelectedPlayers.length < 5) {
                    this.selectedPlayer = player
                    this.currentTeam === 1 ? this.team1SelectedPlayers.push(player) : this.team2SelectedPlayers.push(player)
                    this.category = 'sub-in'
                    this.setStat(player)
                    if (this.currentTeam === 1) {
                        this.sortPlayers(this.team1SelectedPlayers)
                        this.sortPlayers(this.team1BenchPlayers)
                    } else {
                        this.sortPlayers(this.team2SelectedPlayers)
                        this.sortPlayers(this.team2BenchPlayers)
                    }
                }
            },
            removePlayer(player) {
                this.selectedPlayer = player
                if (this.currentTeam === 1 ? this.team1SelectedPlayers.length > 0 : this.team2SelectedPlayers.length > 0) {
                    this.currentTeam === 1 ? this.team1SelectedPlayers = this.team1SelectedPlayers.filter(element => player.id !== element.id) : this.team2SelectedPlayers = this.team2SelectedPlayers.filter(element => player.id !== element.id)
                    this.category = 'sub-out'
                    this.setStat(player)
                    if (this.currentTeam === 1) {
                        this.sortPlayers(this.team1SelectedPlayers)
                        this.sortPlayers(this.team1BenchPlayers)
                    } else {
                        this.sortPlayers(this.team2SelectedPlayers)
                        this.sortPlayers(this.team2BenchPlayers)
                    }
                }
            },
            getTeamLogo(log) {
                return this.googleApiHost + '/' + (this.match.team1.id === log.teamId ? this.match.team1.logo : this.match.team2.logo)
            },
            getMatch() {
                return matchService.getMatch(this.$route.params.matchId).then(resp => {
                    this.match = resp.data
                    this.match.gameRosterTeam1 = this.match.gameRosterTeam1 || []
                    this.match.gameRosterTeam2 = this.match.gameRosterTeam2 || []
                    if (this.match.matchDatetime === null) {
                        this.matchDate = null
                        this.matchTime = null
                    } else {
                        this.matchDate = momentTimezone(this.match.matchDatetime).tz('Europe/Athens').locale('el-GR').format('dddd D/M/y, HH:mm').toString()
                    }
                    this.team1 = resp.data.team1.id
                    this.team2 = resp.data.team2.id
                    // return promises for fetching team players, then populate active players
                    return Promise.all([
                        this.fetchFilteredTeam1Players(resp.data.team1.id),
                        this.fetchFilteredTeam2Players(resp.data.team2.id)
                    ]).then(() => {
                        this.sortPlayers(this.team1Players)
                        this.sortPlayers(this.team2Players)
                        this.getActivePlayers()
                    })
                })
            },
            getActivePlayers() {
                this.team1SelectedPlayers = []
                this.team2SelectedPlayers = []
                matchService.getActivePlayers(this.$route.params.matchId).then(resp => {
                    resp.data.team1Players.forEach(element => {
                        if (this.team1Players.filter(player => player.id === element.playerId).length === 0) {
                            return
                        }
                        this.team1SelectedPlayers.push(this.team1Players.filter(player => player.id === element.playerId)[0])
                        this.sortPlayers(this.team1SelectedPlayers)
                    })
                    resp.data.team2Players.forEach(element => {
                        if (this.team2Players.filter(player => player.id === element.playerId).length === 0) {
                            return
                        }
                        this.team2SelectedPlayers.push(this.team2Players.filter(player => player.id === element.playerId)[0])
                        this.sortPlayers(this.team2SelectedPlayers)
                    })
                })
                this.sortPlayers(this.team1SelectedPlayers)
                this.sortPlayers(this.team2SelectedPlayers)
            },
            getLogText(log) {
                let temp = ''
                Object.keys(log).forEach(key => {
                    if (key === 'defensiveRebounds') {
                        temp += 'defensive rebound'
                    } else if (key === 'offensiveRebounds') {
                        temp += 'offensive rebound'
                    } else if (key === 'turnovers') {
                        temp += 'turnover'
                    } else if (key === 'turnovers') {
                        temp += 'turnover'
                    } else if (key === 'steals') {
                        temp += 'steal'
                    } else if (key === 'assists') {
                        temp += 'assist'
                    } else if (key === 'playerMatchStatus' && log[key] === 'begin') {
                        temp += 'subbed in'
                    } else if (key === 'playerMatchStatus' && log[key] === 'stop') {
                        temp += 'subbed out'
                    } else if (key === 'blockedShots') {
                        temp += 'block'
                    } else if (key === 'personalFouls') {
                        temp += 'personal foul'
                    } else if (key === 'technicalFouls') {
                        temp += 'technical foul'
                    } else if (key === 'unsportsmanlikeFouls') {
                        temp += 'unsportmanlike foul'
                    } else if (key === 'freeThrowsMade' && log[key] === 1) {
                        temp += 'free throw made'
                    } else if (key === 'freeThrowAttempts' && log['freeThrowsMade'] === 0) {
                        temp += 'free throw missed'
                    } else if (key === 'twoPointsMade' && log[key] === 1) {
                        temp += '2pt made'
                    } else if (key === 'twoPointAttempts' && log['twoPointsMade'] === 0) {
                        temp += '2pt missed'
                    } else if (key === 'threePointsMade' && log[key] === 1) {
                        temp += '3pt made'
                    } else if (key === 'threePointAttempts' && log['threePointsMade'] === 0) {
                        temp += '3pt missed'
                    }
                })
                return `#${log.alternativeJersey || log.alternativeJersey === 0 ? log.alternativeJersey : log.jersey} ${temp}`
            },
            getFeed() {
                matchService.getMatchLogs(this.$route.params.matchId).then((resp) => {
                    if (resp.data.length === 0) {
                        this.feed = []
                        this.created = false
                        return
                    }
                    this.feed = resp.data
                        .sort((a, b) => {
                            const toMs = s => {
                                const parts = (s || '').split(':')
                                const min = parseInt(parts[0], 10) || 0
                                const sec = parseInt(parts[1], 10) || 0
                                return min * 60000 + sec * 1000
                            }
                            // descending: newest (largest elapsed) first
                            return toMs(b.timestamp) - toMs(a.timestamp)
                        })
                    // run timer/quarter logic after sorting
                    this.updateTimerFromFeed()
                    this.setQuarterFouls()
                })
            },
            updateTimerFromFeed() {
                if (!this.created) return
                if (this.feed && this.feed.length > 0 && this.feed[0] && this.feed[0].timestamp) {
                    const [minStr = '0', secStr = '0'] = this.feed[0].timestamp.split(':')
                    this.quarter = Math.floor((parseInt(minStr, 10) || 0) / 10) + 1
                    // calculate elapsed seconds until now
                    const totalElapsedSeconds = (parseInt(minStr, 10) || 0) * 60 + (parseInt(secStr, 10) || 0)
                    // the duration of the current quarter in seconds
                    const quarterDurationSec = this.quarter <= 4 ? 10 * 60 : 5 * 60

                    // compute seconds elapsed at the start of this quarter (supports overtime)
                    let quarterStartElapsedSeconds = 0
                    if (this.quarter <= 4) {
                        quarterStartElapsedSeconds = (this.quarter - 1) * 10 * 60
                    } else {
                        // 4 regulation quarters of 10 minutes, any overtime periods are 5 minutes each
                        quarterStartElapsedSeconds = 4 * 10 * 60 + (this.quarter - 1 - 4) * 5 * 60
                    }

                    let elapsedInQuarter = totalElapsedSeconds - quarterStartElapsedSeconds
                    if (elapsedInQuarter < 0) elapsedInQuarter = 0
                    const remainingSeconds = quarterDurationSec - elapsedInQuarter
                    this.timer = Math.max(0, remainingSeconds * 1000)
                } else {
                    this.quarter = 1
                    this.timer = 10 * 60 * 1000
                }
            },
            deleteLog() {
                let log = this.feed.filter((element) => this.logId === element.logId)[0]
                matchService.deleteMatchLog(this.match.id, this.logId).then((resp) => {
                    this.deleteDialog = false
                    this.feed = resp.data
                    if (log.playerMatchStatus === 'stop' || log.playerMatchStatus === 'begin') {
                        this.getActivePlayers()
                    }
                    this.getMatch()
                })
            },
            putBack(selectedPlayer) {
                this.retry = false
                this.overlay = true
                let data = {
                    period: this.quarter,
                    teamId: this.currentTeam === 1 ? this.team1 : this.team2,
                    playerId: selectedPlayer.id,
                    jersey: selectedPlayer.jersey,
                    alternativeJersey: selectedPlayer.alternativeJersey,
                    timestamp: `${this.getMinutes()}:${this.getSeconds()}`
                }
                switch (this.category) {
                case '2pts':
                    data.throwCoordinates = { ...this.shots[0], throwStatus: 'putback' }
                    data.twoPointsMade = 1
                    data.twoPointAttempts = 2
                    data.offensiveRebounds = 1
                    break
                case '3pts':
                    data.throwCoordinates = { ...this.shots[0], throwStatus: 'putback' }
                    data.threePointsMade = 1
                    data.threePointAttempts = 2
                    break
                default:
                    break
                }
                matchService.importMatchLog(this.match.id, data).then((resp) => {
                    this.choice = null
                    this.pointsDialog = false
                    this.foulsDialog = false
                    this.dialog = false
                    setTimeout(() => {
                        this.overlay = false
                        this.dialog = false
                        this.reboundDialog = false
                    }, '500')
                    this.match = resp.data
                    this.match.gameRosterTeam1 = this.match.gameRosterTeam1 || []
                    this.match.gameRosterTeam2 = this.match.gameRosterTeam2 || []
                    this.selectedPlayer = null
                }).catch(() => {
                    this.dialog = false
                    this.pointsDialog = false
                    this.foulsDialog = false
                    this.reboundDialog = false
                    this.playersDialog = false
                    this.overlay = false
                    this.retry = true
                })
            },
            setStat(player) {
                this.retry = false
                this.overlay = true
                let data = {
                    period: this.quarter,
                    teamId: this.currentTeam === 1 ? this.team1 : this.team2,
                    playerId: player ? player.id : 0,
                    jersey: player ? player.jersey : null,
                    alternativeJersey: player ? player.alternativeJersey : null,
                    timestamp: `${this.getMinutes()}:${this.getSeconds()}`
                }
                switch (this.category) {
                case '1pt':
                    if (this.choice === 'made') {
                        data.freeThrowsMade = 1
                        data.freeThrowAttempts = 1
                    } else {
                        data.freeThrowAttempts = 1
                    }
                    break
                case '2pts':
                    data.throwCoordinates = this.shots[0]
                    if (this.choice === 'made') {
                        data.twoPointsMade = 1
                        data.twoPointAttempts = 1
                    } else {
                        data.twoPointAttempts = 1
                    }
                    break
                case '3pts':
                    console.log('in 3pts')
                    console.log(this.shots)
                    data.throwCoordinates = this.shots[0]
                    if (this.choice === 'made') {
                        data.threePointsMade = 1
                        data.threePointAttempts = 1
                    } else {
                        data.threePointAttempts = 1
                    }
                    break
                case 'dreb':
                    data.defensiveRebounds = 1
                    break
                case 'oreb':
                    data.offensiveRebounds = 1
                    break
                case 'to':
                    data.turnovers = 1
                    break
                case 'stl':
                    data.steals = 1
                    break
                case 'asst':
                    data.assists = 1
                    break
                case 'blk':
                    data.blockedShots = 1
                    break
                case 'foul':
                    if (this.choice === 'personal') {
                        data.personalFouls = 1
                    } else if (this.choice === 'technical') {
                        data.technicalFouls = 1
                    } else {
                        data.unsportsmanlikeFouls = 1
                    }
                    break
                case 'sub-in':
                    data.playerMatchStatus = 'begin'
                    break
                case 'sub-out':
                    data.playerMatchStatus = 'stop'
                    break
                default:
                    break
                }
                matchService.importMatchLog(this.match.id, data).then((resp) => {
                    if ((this.category === '2pts' || this.category === '3pts') && this.choice === 'made') {
                        this.choice = null
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.reboundDialog = false
                        this.dialog = false
                        setTimeout(() => {
                            this.overlay = false
                            this.dialog = true
                            this.category = 'asst'
                        }, '500')
                    } else if ((this.category === '2pts' || this.category === '3pts' || this.category === '1pt') && this.choice === 'missed') {
                        this.choice = null
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.dialog = false
                        setTimeout(() => {
                            this.overlay = false
                            if (this.category !== '1pt') {
                                this.reboundDialog = true
                                this.dialog = true
                            } else {
                                this.dialog = false
                            }
                        }, '500')
                    } else if (this.category === 'stl') {
                        this.currentTeam = this.currentTeam === 1 ? 2 : 1
                        this.choice = null
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.reboundDialog = false
                        this.dialog = false
                        setTimeout(() => {
                            this.dialog = true
                            this.overlay = false
                            this.category = 'to'
                        }, '500')
                    } else if (this.category === 'foul') {
                        setTimeout(() => {
                            this.overlay = false
                        }, '500')
                        this.dialog = false
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.category = null
                        this.choice = null
                        this.reboundDialog = false
                        this.pauseTimer()
                    } else {
                        this.dialog = false
                        this.pointsDialog = false
                        this.foulsDialog = false
                        this.category = null
                        this.choice = null
                        this.reboundDialog = false
                        setTimeout(() => {
                            this.overlay = false
                        }, '500')
                    }
                    this.match = resp.data
                    this.match.gameRosterTeam1 = this.match.gameRosterTeam1 || []
                    this.match.gameRosterTeam2 = this.match.gameRosterTeam2 || []
                    this.selectedPlayer = null
                }).catch(() => {
                    this.dialog = false
                    this.pointsDialog = false
                    this.foulsDialog = false
                    this.reboundDialog = false
                    this.playersDialog = false
                    this.overlay = false
                    this.retry = true
                })
            },
            fetchFilteredTeam1Players(id) {
                this.loading = true
                return teamService.getTeam(id).then(resp => {
                    this.team1Players = resp.data.players
                    this.loading = false
                })
            },
            fetchFilteredTeam2Players(id) {
                this.loading = true
                return teamService.getTeam(id).then(resp => {
                    this.team2Players = resp.data.players
                    this.loading = false
                })
            },
            getPlayerText(item) {
                return `#${item.jersey} ${item.name}`
            },
            // openFullscreen() {
            //     var elem = document.getElementById('stats')
            //     if (elem.requestFullscreen) {
            //         elem.requestFullscreen()
            //     } else if (elem.webkitRequestFullscreen) { /* Safari */
            //         elem.webkitRequestFullscreen()
            //     } else if (elem.msRequestFullscreen) { /* IE11 */
            //         elem.msRequestFullscreen()
            //     }
            // },
            switchTimer() {
                this.paused = !this.paused
                matchService.editTimer(this.match.id, this.paused ? 'start' : 'stop', this.timer, this.quarter).then(() => {}).catch(() => {})
                if (!this.paused) {
                    clearInterval(this.timerInterval)
                } else if (this.timer > 0) {
                    this.timerInterval = setInterval(() => {
                        this.timer = this.timer - 1000
                    }, 1000)
                }
            },
            pauseTimer() {
                this.paused = false
                matchService.editTimer(this.match.id, 'stop', this.timer, this.quarter).then(() => {}).catch(() => {})
                clearInterval(this.timerInterval)
            },
            timeout() {
                this.paused = false
                matchService.editTimer(this.match.id, 'timeout', this.timer, this.quarter).then(() => {}).catch(() => {})
                clearInterval(this.timerInterval)
            },
            changeTimer() {
                this.timer = parseInt(this.newMinutes) * 60000 + parseInt(this.newSeconds) * 1000
            },
            updateSelectedPlayerAlternativeJersey() {
                this.overlay = true
                playerService.setAlternativeJerseyOnPlayer(this.selectedPlayer.id, this.selectedPlayer.alternativeJersey.toString()).then(() => {
                    this.overlay = false
                    if (this.currentTeam === 1) {
                        this.sortPlayers(this.team1SelectedPlayers)
                        this.sortPlayers(this.team1BenchPlayers)
                        this.sortPlayers(this.team1Players)
                    } else {
                        this.sortPlayers(this.team2SelectedPlayers)
                        this.sortPlayers(this.team2BenchPlayers)
                        this.sortPlayers(this.team2Players)
                    }
                    // show success snackbar
                    this.snackbarText = 'Alternative jersey updated'
                    this.snackbarColor = 'success'
                    this.showSnackbar = true
                }).catch(() => {
                    this.selectedPlayer.alternativeJersey = null
                    this.overlay = false
                    // show error snackbar
                    this.snackbarText = 'Failed to update alternative jersey'
                    this.snackbarColor = 'error'
                    this.showSnackbar = true
                })
            }
        }
    }
</script>

<style scoped>
    .match-timer{
        font-weight: 700;
        border: 2px solid black;
        border-radius: 10px;
    }

    .match-timer-danger{
        border-color: red !important;
        color: red !important;
    }
    .overlay {
        position: absolute;
        bottom: 0;
        background: rgb(0, 0, 0);
        background: rgba(0, 0, 0, 0.5); /* Black see-through */
        color: #f1f1f1;
        width: 100%;
        transition: .5s ease;
        opacity:0;
        color: white;
        font-size: 20px;
        padding: 20px;
        text-align: center;
    }

    .full-width-on-open.v-expansion-panel--active .v-expansion-panel-content {
        max-height: calc(100vh - 56px);
        overflow: auto;
    }

    /* horizontal scrolling for bench players */
    .bench-scroll {
        display: flex;
        flex-direction: row;
        gap: 12px;
        padding: 12px;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }

    .bench-item {
        flex: 0 0 auto;
        display: inline-flex;
        align-items: center;
    }

    .bench-entry {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        min-width: 120px;
    }

    .bench-text {
        margin-top: 8px;
        text-align: center;
        font-weight: 600;
    }

    .selectedPlayer {
        border: 4px solid orangered;
    }
</style>
